import { getChromeSessionStorage } from './wrappers';

/**
 * Returns if it's the first start of the extension in the current session.
 */
export const isSessionFirstStart = async () =>
  (await getChromeSessionStorage()?.get('sessionStarted'))?.sessionStarted ===
  undefined;

/**
 * Set that the extension was already started in this session.
 */
export const setSessionStarted = () =>
  getChromeSessionStorage()?.set({ sessionStarted: true });

export const clearSessionStorage = () => getChromeSessionStorage()?.clear();
